import script from "./ExpendeduriasView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExpendeduriasView.vue?vue&type=script&setup=true&lang=ts"

import "./ExpendeduriasView.vue?vue&type=style&index=0&id=6997c84b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6997c84b"]])

export default __exports__